import React from "react";
import { CardTheme } from "../types";

interface WildSymbolProps {
  theme: CardTheme;
}

export const WildSymbol: React.FC<WildSymbolProps> = React.memo(({ theme }) => {
  const { width, height } = theme.card;
  const centerX = width / 2;
  const centerY = height / 2;
  const size = Math.min(width, height) * 0.3;
  const cornerFontSize = width * 0.12;

  // Four colored quadrants representing the four colors
  return (
    <g>
      {/* Red quadrant (top-left) */}
      <path
        d={`M ${centerX} ${centerY} L ${centerX} ${centerY - size} L ${centerX - size} ${centerY} Z`}
        fill={theme.colors.red}
      />
      {/* Blue quadrant (top-right) */}
      <path
        d={`M ${centerX} ${centerY} L ${centerX + size} ${centerY} L ${centerX} ${centerY - size} Z`}
        fill={theme.colors.blue}
      />
      {/* Green quadrant (bottom-left) */}
      <path
        d={`M ${centerX} ${centerY} L ${centerX - size} ${centerY} L ${centerX} ${centerY + size} Z`}
        fill={theme.colors.green}
      />
      {/* Yellow quadrant (bottom-right) */}
      <path
        d={`M ${centerX} ${centerY} L ${centerX} ${centerY + size} L ${centerX + size} ${centerY} Z`}
        fill={theme.colors.yellow}
      />
      {/* Center circle */}
      <circle
        cx={centerX}
        cy={centerY}
        r={size * 0.2}
        fill={theme.colors.wild}
      />
      
      {/* Top-left corner W */}
      <text
        x={width * 0.15}
        y={height * 0.2}
        fontSize={cornerFontSize}
        fontWeight="bold"
        fill={theme.symbol.color}
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
      >
        W
      </text>

      {/* Bottom-right corner W (rotated) */}
      <text
        x={width * 0.85}
        y={height * 0.8}
        fontSize={cornerFontSize}
        fontWeight="bold"
        fill={theme.symbol.color}
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
        transform={`rotate(180 ${width * 0.85} ${height * 0.8})`}
      >
        W
      </text>
    </g>
  );
});

WildSymbol.displayName = "WildSymbol";
